import Vue from 'vue'

import routes from './routes'
import request from './request'
import notification from './notification'

Vue.directive('focus', {
  // When the bound element is inserted into the DOM...
  inserted: function (el) {
    // Focus the element
    el.focus()
  }
})

export default new Vue({
  mixins: [
    routes,
    request,
    notification
  ],
  
  data(){
    return {
      login: {
        success: false
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/shared/index.js